/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Method_GoogleInputs */

const en_invite_method_google = /** @type {(inputs: Invite_Method_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with Google`)
};

/** @type {(inputs: Invite_Method_GoogleInputs) => LocalizedString} */
const ar_invite_method_google = en_invite_method_google;

/** @type {(inputs: Invite_Method_GoogleInputs) => LocalizedString} */
const he_invite_method_google = en_invite_method_google;

/** @type {(inputs: Invite_Method_GoogleInputs) => LocalizedString} */
const ur_invite_method_google = en_invite_method_google;

/** @type {(inputs: Invite_Method_GoogleInputs) => LocalizedString} */
const es_invite_method_google = en_invite_method_google;

/** @type {(inputs: Invite_Method_GoogleInputs) => LocalizedString} */
const fr_invite_method_google = en_invite_method_google;

/** @type {(inputs: Invite_Method_GoogleInputs) => LocalizedString} */
const de_invite_method_google = en_invite_method_google;

/** @type {(inputs: Invite_Method_GoogleInputs) => LocalizedString} */
const pt_invite_method_google = en_invite_method_google;

/** @type {(inputs: Invite_Method_GoogleInputs) => LocalizedString} */
const hi_invite_method_google = en_invite_method_google;

/** @type {(inputs: Invite_Method_GoogleInputs) => LocalizedString} */
const bn_invite_method_google = en_invite_method_google;

/**
* | output |
* | --- |
* | "Continue with Google" |
*
* @param {Invite_Method_GoogleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_method_google = /** @type {((inputs?: Invite_Method_GoogleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Method_GoogleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_method_google(inputs)
	if (locale === "he") return he_invite_method_google(inputs)
	if (locale === "ur") return ur_invite_method_google(inputs)
	if (locale === "es") return es_invite_method_google(inputs)
	if (locale === "fr") return fr_invite_method_google(inputs)
	if (locale === "de") return de_invite_method_google(inputs)
	if (locale === "pt") return pt_invite_method_google(inputs)
	if (locale === "hi") return hi_invite_method_google(inputs)
	if (locale === "bn") return bn_invite_method_google(inputs)
	return /** @type {LocalizedString} */ ("Continue with Google")
});